<template>
    <div class="d-flex flex-column nav-items">
        <NuxtLink
            v-for="step in getRegistrationSteps?.filter(regStep => !regStep.hidden)"
            :key="step.name"
            class="nav-item"
            :to="{
                path: localePath({name: 'registration-id-' + step.name}),
                query: $route.query
            }"
            :class="{'disabled': step.disabled}">
            <Component
                :is="'MenuItem' + step.name.charAt(0).toUpperCase() + step.name.slice(1)"
                class="menu-items" />
        </NuxtLink>
    </div>
</template>

<script>
import MenuItemParticipants from "@/components/layouts/eventRegistration/MenuItemParticipants";
import MenuItemRegistrationDetails from "@/components/layouts/eventRegistration/MenuItemRegistrationDetails";
import MenuItemParticipantsDetails from "@/components/layouts/eventRegistration/MenuItemParticipantsDetails";
import MenuItemPayment from "@/components/layouts/eventRegistration/MenuItemPayment";
import MenuItemRegSummary from "@/components/layouts/eventRegistration/MenuItemRegSummary";
import registrationStepsAndValidationMixin from "@/mixins/registration/registrationStepsAndValidationMixin";
import MenuItemRegStart from "@/components/layouts/eventRegistration/MenuItemRegStart";


export default {
    name: "RegistrationMenu",
    components: {
        MenuItemRegSummary,
        MenuItemRegStart,
        MenuItemPayment,
        MenuItemParticipantsDetails,
        MenuItemRegistrationDetails,
        MenuItemParticipants
    },
    mixins: [registrationStepsAndValidationMixin],
    data() {
        return {
            stepName: null
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-items > * {
    margin-bottom: map-get($spacers, 2);
}

.nav-item {
    color: $nav-item-color;
    font-size: $font-size-base;
    padding: map-get($spacers, 1) map-get($spacers, 3);
    user-select: none;

    > span {
        margin-left: map-get($spacers, 1);
    }
}

.nav-item.nuxt-link-active {
    background: $gray-400;
    border-radius: 0.375rem;
    color: $nav-item-hover-color !important;

}

.nav-item:hover {
    color: $nav-item-hover-color;
}

.nav-item.disabled {
    color: $nav-item-disabled-color;
    pointer-events: none;
}

.menu-items > :nth-child(2) {
    margin-left: map-get($spacers, 2);
}
</style>
